<template>
	<section v-if="ok" :class="classes">
		<div :class="[{ 'info-panel': true }]">
			<h2 v-if="title" v-html="title" class="info-panel-title" />

			<p
				v-if="description"
				v-html="description"
				class="info-panel-description"
			/>

			<hr v-if="title || description" />

			<slot name="above-graph" />

			<component
				:is="chartType"
				:chartdata="chartdata"
				:options="options"
				:style="styles"
				ref="chart1"
				v-if="
					chartdata &&
					chartdata.datasets &&
					chartdata.datasets.length > 0
				"
				@chart-click="handleClick"
				@label-click="labelClick"
			/>

			<slot name="below-graph" />

			<InfoPanelOverlay
				:settings="overlay"
				@overlayClicked="overlayClicked"
			/>
		</div>
	</section>
</template>

<script>
	import { computed } from "vue";
	import LineGraph from "./LineGraph.vue";
	import PieChart from "./PieChart.vue";
	import Doughnut from "./Doughnut.vue";
	import PolarArea from "./PolarArea.vue";
	import InfoPanelOverlay from "./../InfoPanelOverlay.vue";
	export default {
		name: "GraphWrap",
		components: {
			InfoPanelOverlay,
			LineGraph,
			PieChart,
			Doughnut,
			PolarArea,
		},
		props: {
			title: {
				type: String,
				default: null,
			},
			description: {
				type: String,
				default: null,
			},
			chartdata: {
				type: [Object, Array],
				default: null,
			},
			options: {
				type: Object,
				default: null,
			},
			noPad: {
				type: Boolean,
				default: false,
			},
			chartType: {
				type: String,
				default: "LineGraph",
				validator: function (value) {
					return (
						[
							"LineGraph",
							"PieChart",
							"Doughnut",
							"PolarArea",
						].indexOf(value) > -1
					);
				},
			},
			size: {
				type: String,
				default: "",
			},
			overlay: {
				type: [Object, Boolean],
				default: false,
			},
			height: {
				type: String,
				default: "",
			},
		},
		setup(props, { emit }) {
			const ok = computed(() => {
				return (
					props.chartdata &&
					typeof props.chartdata === "object" &&
					Array.isArray(props.chartdata) === false &&
					Object.keys(props.chartdata).length > 0 &&
					props.chartdata.datasets
				);
			});

			const classes = computed(() => {
				const c = {};
				if (props.size) {
					c[props.size] = true;
				}
				if (props.noPad) {
					c["no-pad"] = true;
				}
				return c;
			});

			const styles = computed(() => {
				let styles = [];
				if (!!props.height) {
					styles.push(`height: ${props.height};`);
				} else {
					// Default height for charts if none specified
					styles.push("height: 400px;");
				}
				return styles.join(" ");
			});

			const overlayClicked = () => {
				if (props.overlay.click) {
					const cv = props.overlay.clickVars
						? props.settings.clickVars
						: false;
					emit(props.overlay.click, cv);
				}
			};

			const labelClick = (info) => {
				emit("label-click", info);
			};

			const handleClick = (event, array) => {
				emit("chart-click", { event, array });
			};

			return {
				ok,
				classes,
				styles,
				overlayClicked,
				labelClick,
				handleClick,
			};
		},
	};
</script>
<style lang="less" scoped>
	.no-pad {
		.info-panel {
			padding: 0;
			border: none;
			min-height: 300px;
		}
	}
</style>
